<template>
	<div>
		<case-form :schema="schema" class="mt6" />

		<div class="xs-12 fs4 fw7 mb2 mt6">过去 2 年s</div>
		<j-accordion
			v-for="i in 4"
			:key="i"
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="mr1">旅游的详情</span>
				{{ i }}
			</div>
			<div slot="body" class="p6 bg5">
				<case-form :schema="schemaTravelPast2Years(i)" :isBoxed="false" />
			</div>
		</j-accordion>

		<div class="xs-12 fs4 fw7 mb2 mt6">未来 2 年</div>
		<j-accordion
			v-for="i in 4"
			:key="i"
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="mr1">旅游的详情</span>
				{{ i }}
			</div>
			<div slot="body" class="p6 bg5">
				<case-form :schema="schemaTravelNext2Years(i)" :isBoxed="false" />
			</div>
		</j-accordion>

		<case-form :schema="schema2" class="mt6 mb6" />
		<div class="fs4 fw7 lh125 mt6 mb2">
			提供您过去14天的旅行记录：
		</div>
		<j-accordion
			v-for="i in 3"
			:key="i"
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="mr1">旅游模式</span>
				{{ i }}
			</div>
			<div slot="body" class="p6 bg5">
				<case-form :schema="schemaTravelPast14Days(i)" :isBoxed="false" />
			</div>
		</j-accordion>

		<case-form :schema="schemaOthers" class="mt6" />
	</div>
</template>

<script>
import CaseForm from "@/modules/caseManagement/components/CaseForm/CaseForm.vue"
import JAccordion from "@/components/JAccordion/"

export default {
	components: {
		CaseForm,
		JAccordion
	},

	computed: {
		schema() {
			return [
				{
					label: "您是否计划前往当前居住国以外的国家旅行？",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0willTravelOutsideCountryOfResidenceCN`,
					props: {
						suggest: {
							typeIncludes: `willTravelOutsideCountryOfResidenceCN`
						},
						createOptions: {
							type: `willTravelOutsideCountryOfResidenceCN`,
							dataType: "boolean"
						}
					}
				}
			]
		},
		schema2() {
			return [
				{
					label: `您过去14天有旅行吗？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasTravelledPast14DaysCN`,
					props: {
						suggest: {
							typeIncludes: `hasTravelledPast14DaysCN`
						},
						createOptions: {
							type: `hasTravelledPast14DaysCN`,
							dataType: "boolean"
						}
					}
				}
			]
		},
		schemaOthers() {
			return [
				{
					label: "您是否有计划到其他国家定居？",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasPlanToMigrateCN`,
					props: {
						suggest: {
							typeIncludes: `hasPlanToMigrateCN`
						},
						createOptions: {
							type: `hasPlanToMigrateCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "今后的两年内，您是否有计划在当前居住国以外的国家居住？",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasPlanToMigrateIn2YearsCN`,
					props: {
						suggest: {
							typeIncludes: `hasPlanToMigrateIn2YearsCN`
						},
						createOptions: {
							type: `hasPlanToMigrateIn2YearsCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "城市",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0migrateCityCN`,
					props: {
						suggest: {
							typeIncludes: `migrateCityCN`
						},
						createOptions: {
							type: `migrateCityCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "国家",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0migrateCountryCN`,
					props: {
						suggest: {
							typeIncludes: `migrateCountryCN`
						},
						createOptions: {
							type: `migrateCountryCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "写出您计划居住的城市与国家：",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0migrateReasonCN`,
					props: {
						suggest: {
							typeIncludes: `migrateReasonCN`
						},
						createOptions: {
							type: `migrateReasonCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "您会在新居住地停留多久？",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0migrateDurationCN`,
					props: {
						suggest: {
							typeIncludes: `migrateDurationCN`
						},
						createOptions: {
							type: `migrateDurationCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "您是否计划回到您现在的居住国？",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0willReturnAfterMigrationCN`,
					props: {
						suggest: {
							typeIncludes: `willReturnAfterMigrationCN`
						},
						createOptions: {
							type: `willReturnAfterMigrationCN`,
							dataType: "boolean"
						}
					}
				}
			]
		}
	},

	methods: {
		schemaTravelPast2Years(i) {
			return [
				{
					label: `国家`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0past2YearsCountry${i}CN`,
					props: {
						suggest: {
							typeIncludes: `past2YearsCountry${i}CN`
						},
						createOptions: {
							type: `past2YearsCountry${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `到访城市`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0past2YearsCitiesVisited${i}CN`,
					props: {
						suggest: {
							typeIncludes: `past2YearsCitiesVisited${i}CN`
						},
						createOptions: {
							type: `past2YearsCitiesVisited${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `逗留时间`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0past2YearsDurationOfStay${i}CN`,
					props: {
						suggest: {
							typeIncludes: `past2YearsDurationOfStay${i}CN`
						},
						createOptions: {
							type: `past2YearsDurationOfStay${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `到访次数`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0past2YearsFrequency${i}CN`,
					props: {
						suggest: {
							typeIncludes: `past2YearsFrequency${i}CN`
						},
						createOptions: {
							type: `past2YearsFrequency${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `上次到访日期`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0past2YearsDateLastVisited${i}CN`,
					props: {
						suggest: {
							typeIncludes: `past2YearsDateLastVisited${i}CN`
						},
						createOptions: {
							type: `past2YearsDateLastVisited${i}CN`,
							dataType: "date"
						}
					}
				},
				{
					label: `旅行目的`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0past2YearsPurpose${i}CN`,
					props: {
						suggest: {
							typeIncludes: `past2YearsPurpose${i}CN`
						},
						createOptions: {
							type: `past2YearsPurpose${i}CN`,
							dataType: "string"
						}
					}
				}
			]
		},

		schemaTravelNext2Years(i) {
			return [
				{
					label: `国家`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0next2YearsCountry${i}CN`,
					props: {
						suggest: {
							typeIncludes: `next2YearsCountry${i}CN`
						},
						createOptions: {
							type: `next2YearsCountry${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `到访城市`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0next2YearsCitiesVisited${i}CN`,
					props: {
						suggest: {
							typeIncludes: `next2YearsCitiesVisited${i}CN`
						},
						createOptions: {
							type: `next2YearsCitiesVisited${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `逗留时间`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0next2YearsDurationOfStay${i}CN`,
					props: {
						suggest: {
							typeIncludes: `next2YearsDurationOfStay${i}CN`
						},
						createOptions: {
							type: `next2YearsDurationOfStay${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `到访次数`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0next2YearsFrequency${i}CN`,
					props: {
						suggest: {
							typeIncludes: `next2YearsFrequency${i}CN`
						},
						createOptions: {
							type: `next2YearsFrequency${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `上次到访日期`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0next2YearsDateLastVisited${i}CN`,
					props: {
						suggest: {
							typeIncludes: `next2YearsDateLastVisited${i}CN`
						},
						createOptions: {
							type: `next2YearsDateLastVisited${i}CN`,
							dataType: "date"
						}
					}
				},
				{
					label: `旅行目的`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0next2YearsPurpose${i}CN`,
					props: {
						suggest: {
							typeIncludes: `next2YearsPurpose${i}CN`
						},
						createOptions: {
							type: `next2YearsPurpose${i}CN`,
							dataType: "string"
						}
					}
				}
			]
		},

		schemaTravelPast14Days(i) {
			return [
				{
					label: `国家`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0past14DaysCountry${i}CN`,
					props: {
						suggest: {
							typeIncludes: `past14DaysCountry${i}CN`
						},
						createOptions: {
							type: `past14DaysCountry${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `城市`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0past14DaysCity${i}CN`,
					props: {
						suggest: {
							typeIncludes: `past14DaysCity${i}CN`
						},
						createOptions: {
							type: `past14DaysCity${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `入境日期`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0past14DaysArrivalDate${i}CN`,
					props: {
						suggest: {
							typeIncludes: `past14DaysArrivalDate${i}CN`
						},
						createOptions: {
							type: `past14DaysArrivalDate${i}CN`,
							dataType: "date"
						}
					}
				},
				{
					label: `离境日期`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0past14DaysDepartureDate${i}CN`,
					props: {
						suggest: {
							typeIncludes: `past14DaysDepartureDate${i}CN`
						},
						createOptions: {
							type: `past14DaysDepartureDate${i}CN`,
							dataType: "date"
						}
					}
				}
			]
		}
	}
}
</script>
